import { NgModule } from '@angular/core';
import { CreditHealthComponent } from './containers/credit-health/credit-health.component';
import { CommonModule, CurrencyPipe, DecimalPipe } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from 'src/assets/material/material.module';
import { CreditScoreComponent } from './components/credit-score/credit-score.component';
import { MoneyManagerComponent } from './components/money-manager/money-manager.component';
import { DebtManagerComponent } from './components/debt-manager/debt-manager.component';

@NgModule({
  imports: [CommonModule, SharedModule, MaterialModule],
  declarations: [CreditHealthComponent, CreditScoreComponent, MoneyManagerComponent, DebtManagerComponent],
  exports: [CreditHealthComponent],
  providers: [CurrencyPipe, DecimalPipe],
})
export class CreditHealthModule {}
